import { NamedImage } from "./ImageStore";

export const StickerTrayCanvasDrawer = {
    canvas: null as HTMLCanvasElement | null,
    ctx: null as CanvasRenderingContext2D | null,
    namedImages: [] as NamedImage[],
    imagesBounds: [] as { leftBound: number; rightBound: number }[],
    offsetX: 0,
    dpr: 1,
    startX: 20,
    stickerSectionHeight: null as null | number,

    initialize(canvas: HTMLCanvasElement, ctx: CanvasRenderingContext2D, dpr: number, stickerSectionHeight: number) {
        this.canvas = canvas;
        this.ctx = ctx;
        this.dpr = dpr;
        this.stickerSectionHeight = stickerSectionHeight
        this.redrawStickerTrayCanvas();
    },

    redrawStickerTrayCanvas: function () {
        if (!this.canvas || !this.ctx || !this.stickerSectionHeight) return;

        const ctx = this.ctx;
        const canvas = this.canvas;

        ctx.clearRect(0, 0, canvas.width, canvas.height);

        const gap = 20;
        const maxHeight = this.stickerSectionHeight;

        let startX = 20;

        ctx.save();
        ctx.translate(this.offsetX, 0);

        this.imagesBounds.length = 0

        for (let i = 0; i < this.namedImages.length; i++) {
            const namedImage = this.namedImages[i];
            const img = namedImage.img
            const scale = maxHeight / img.height;
            const width = img.width * scale;
            const height = maxHeight;

            const imageBounds = { leftBound: startX, rightBound: startX + width }
            this.imagesBounds.push(imageBounds)

            ctx.drawImage(img, startX, 0, width, height);

            startX += width + gap;
        }

        this.startX = startX

        ctx.restore();
    }
};
